

import {
  isGreeting,
  isExplicitApplyLeave,
  isExplicitApplyWFH,
  isCancel
} from "../textUtils";

import { searchPolicy } from "../OrgPolicys/policySearch";
import { generateAnswer } from "../responsesService";
import { handleApplyLeave } from "./handleApplyLeave";
import { handleApplyWFH } from "./handleApplyWFH";
import { sessionStore } from "./sessionStore";

export const handleAIService = async (userMessage) => {
  const msg = userMessage.toLowerCase().trim();

  // 1️⃣ Greeting
  if (!sessionStore.activeIntent && isGreeting(msg)) {
    return {
        message: "👋 Hi! I can help you with:\n\n• Apply leave or WFH\n• Leave & WFH policy questions\n• Upcoming holidays\n\nHow can I assist you today?"
     };
  }

  // 2️⃣ Cancel active flow
  if (sessionStore.activeIntent && isCancel(msg)) {
    resetSession();
    return { message: " Action cancelled. How can I help you?" };
  }

  // 3️⃣ Continue active leave flow
  if (sessionStore.activeIntent === "APPLY_LEAVE") {
    return await handleApplyLeave(userMessage);
  }

  // 4️⃣ Continue active WFH flow
  if (sessionStore.activeIntent === "APPLY_WFH") {
    return await handleApplyWFH(userMessage);
  }

  // 5️⃣ Start WFH flow (check before leave — more specific)
  if (isExplicitApplyWFH(msg)) {
    return await handleApplyWFH();
  }

  // 6️⃣ Start leave flow
  if (isExplicitApplyLeave(msg)) {
    return await handleApplyLeave();
  }

  // 7️⃣ Policy search + AI answer
  
  // const policyText = await searchPolicy(userMessage);

  // const answer = await generateAnswer({
  //   question: userMessage,
  //   context: policyText
  // });
    console.log("🔍 Searching policy for:", userMessage);
  const policyText = await searchPolicy(userMessage);
  console.log("📄 Policy found:", policyText);

  const answer = await generateAnswer({
    question: userMessage,
    context: policyText
  });

  console.log("💬 Answer:", answer);


  return { message: answer };
};

const resetSession = () => {
  sessionStore.activeIntent = null;
  sessionStore.payload = {};
  sessionStore.lastAskedField = null;
};

